module.exports = __webpack_public_path__ + "static/media/vietnamtours.b34dc465.png";